import { OdbcCopySource } from './../../../pipeline/copysource/odbc.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import moment from 'moment-timezone';
import { ValueAdapter } from '../../value.adapter';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OdbcCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        queryTimeout: '*'
    }
})
export class OdbcCopySourceAdapter extends CopySourceAdapter<OdbcCopySource, Model.OdbcSource> {
    protected override async _toResource(copySource: OdbcCopySource): Promise<Model.OdbcSource> {
        const result = this._toTabularResource(copySource, Metamodel.modelFor(OdbcCopySource).name);

        try {
            result.queryTimeout =
                typeof copySource.queryTimeout === 'number'
                    ? moment.duration(copySource.queryTimeout, 'minutes').format('hh:mm:ss', {
                          trim: false
                      })
                    : ValueAdapter.toResource(copySource, OdbcCopySource.QUERY_TIMEOUT);
        } catch {
            this._logError('Failed to convert queryTimeout into TimeSpan');
        }

        return result;
    }

    protected override async _toModel(resource: Model.OdbcSource, copyActivity: CopyActivity): Promise<OdbcCopySource> {
        const result = this._toTabularModel(resource, copyActivity, OdbcCopySource.MODEL) as OdbcCopySource;

        try {
            if (resource.queryTimeout == null) {
                result.queryTimeout = undefined;
            } else {
                if (typeof resource.queryTimeout === 'string' && !isLogicAppExpression(resource.queryTimeout)) {
                    result.queryTimeout = moment.duration(resource.queryTimeout).asMinutes();
                } else {
                    ValueAdapter.toModel(result, OdbcCopySource.QUERY_TIMEOUT, resource.queryTimeout);
                }
            }
        } catch {
            this._logError('Failed to convert queryTimeout into number');
        }
        return result;
    }
}
